export const ABM = 'ABM';
export const ACCOUNTING = 'ACCOUNTING';
export const ANALYTICS = 'ANALYTICS';
export const AUTOMATION = 'AUTOMATION';
export const BRAND_PROTECTION = 'BRAND_PROTECTION';
export const CALL_CENTER = 'CALL_CENTER';
export const CMS = 'CMS';
export const CRM = 'CRM';
export const CUSTOMER_SUCCESS = 'CUSTOMER_SUCCESS';
export const DATA_MANAGEMENT = 'DATA_MANAGEMENT';
export const DROP_SHIPPING = 'DROP_SHIPPING';
export const EMERCHANDISING = 'EMERCHANDISING';
export const ECOMMERCE = 'ECOMMERCE';
export const EMAIL = 'EMAIL';
export const EMPLOYEE_ENGAGEMENT = 'EMPLOYEE_ENGAGEMENT';
export const ERP = 'ERP';
export const EVENT = 'EVENT';
export const FIELD_SERVICE_MANAGEMENT = 'FIELD_SERVICE_MANAGEMENT';
export const HELP_DESK = 'HELP_DESK';
export const IPAAS = 'IPAAS';
export const KNOWLEDGE_BASE = 'KNOWLEDGE_BASE';
export const LEAD_GEN = 'LEAD_GEN';
export const LEARNING_MANAGEMENT_SYSTEM = 'LEARNING_MANAGEMENT_SYSTEM';
export const LIVE_CHAT = 'LIVE_CHAT';
export const PARTNER_RELATIONSHIP_MANAGEMENT = 'PARTNER_RELATIONSHIP_MANAGEMENT';
export const PAYMENT_GATEWAYS = 'PAYMENT_GATEWAYS';
export const PAYROLL = 'PAYROLL';
export const POS = 'POS';
export const PPC = 'PPC';
export const PRODUCT_REVIEWS = 'PRODUCT_REVIEWS';
export const PROJECT = 'PROJECT';
export const SALES = 'SALES';
export const SCHEDULING = 'SCHEDULING';
export const SEO = 'SEO';
export const SHOPPING_CART = 'SHOPPING_CART';
export const SMS = 'SMS';
export const SOCIAL = 'SOCIAL';
export const SUBSCRIPTION_MANAGEMENT = 'SUBSCRIPTION_MANAGEMENT';
export const SURVEY = 'SURVEY';
export const TICKETING = 'TICKETING';
export const VIDEO = 'VIDEO';
export const WEBINAR = 'WEBINAR';
export const WEBSITE = 'WEBSITE';
export const WORDPRESS = 'WORDPRESS';
export const WORKFLOW = 'WORKFLOW';